<template>
  <v-data-table
    :items="localItems"
    :headers-length="2"
    :pagination.sync="pagination"
    hide-actions
  >
    <template v-slot:headers>
      <tr>
        <th class="text-uppercase text-xs-left pa-2">
          Name
        </th>
        <th class="text-uppercase text-xs-left pa-2">
          Status
        </th>
      </tr>
      <tr>
        <td colspan="2" class="pa-2">
          <v-text-field
            v-model.trim="search"
            append-icon="search"
            class="ma-0 pa-0"
            label="Поиск"
            single-line
            small
            hide-details
          ></v-text-field>
        </td>
      </tr>
    </template>

    <template v-slot:items="{ item }">
      <tr>
        <td class="text-xs-left pa-2">
          <router-link
            @click.prevent.stop
            :to="linkTo(item)"
            :class="isTypeClass(item.type)"
          >
            {{ item.name }}
          </router-link>
        </td>
        <td class="text-xs-left pa-2">
          {{ item.status.replace(/\_/g, ' ').toLowerCase() }}
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'dataTable',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      search: '',
      pagination: {
        descending: false,
        rowsPerPage: -1,
        sortBy: 'scheduled_date_rng.from.value',
      },
    };
  },
  computed: {
    localItems() {
      return this.items.filter(item => {
        return item.name
          .toLowerCase()
          .includes(this.search.toLowerCase());
      });
    },
  },
  methods: {
    linkTo(item) {
      return {
        name: this.allRoutes[item.type].children[`${ item.type }Detail`].name,
        params: {
          id: item.id,
          from: this.$route.name,
        },
      };
    },
    isTypeClass(type) {
      return type === 'trial' ? 'green--text' : 'grey--text';
    },
  },
};
</script>
